import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  ButtonComponent,
} from '@predigle/micro/component-ui';
import { Router } from '@angular/router';
import { ToastService } from '../../services/toast.service';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-databridge',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonComponent,
    MatIcon,
  ],
  templateUrl: './databridge.component.html',
  styleUrls: ['./databridge.component.scss'],
})
export class DataBridgeComponent {
  step: 'selection' | 'connection' = 'selection';
  hasDataBridge: boolean | null = null;
  selectedDeviceId: string | null = null;

  availableDevices = [
    {
      id: '1',
      name: 'Boatmaster Beacon',
      icon: 'assets/login/bluetoth_icon.svg',
    },
    {
      id: '2',
      name: 'BlueDock Sensor',
      icon: 'assets/login/bluetoth_icon.svg',
    },
    {
      id: '3',
      name: 'HarborLink Module',
      icon: 'assets/login/bluetoth_icon.svg',
    },
    { id: '4', name: 'Seasense Hub', icon: 'assets/login/bluetoth_icon.svg' },
  ];

  constructor(private router: Router, public toast: ToastService) {}

  continue() {
    if (this.hasDataBridge === true) {
      this.step = 'connection';
    } else if (this.hasDataBridge === false) {
      this.router.navigate(['/home']);
    }
  }

  selectDevice(id: string) {
    this.selectedDeviceId = id;
  }

  goBack() {
    if (this.step === 'connection') {
      this.step = 'selection';
    } else {
      window.history.back();
    }
  }

  next() {
    if (this.step === 'connection' && !this.selectedDeviceId) {
      this.showError('Please select a device to connect');
      return;
    }
    this.router.navigate(['/home']);
  }

  private showError(message: string) {
    this.toast.error(message);
  }
}
